import { useState } from "react";
import { OfficeCard } from "./OfficeCard";

type TabType = "all" | "regional" | "international";

export default function OfficeLocations() {
  const [activeTab, setActiveTab] = useState<TabType>("all");

  const offices = {
    main: {
      type: "Main Headquarters",
      title: "123 Alkina Plaza, City Center, New York",
      description: "Our main headquarters serve as heart of Alkina Realty. This is where our core team operates, driving excellence and innovation.",
      email: "info@alkinarealty.com",
      phone: "+1 (555) 123-4567",
      location: "New York",
    },
    regional: {
      type: "Regional Offices",
      title: "456 Urban Avenue, Downtown, Los Angeles",
      description: "Our regional office extends our presence with local experts who understand the nuances of the Los Angeles real estate market.",
      email: "regional@alkinarealty.com",
      phone: "+1 (555) 628-7890",
      location: "Los Angeles",
    },
  };

  return (
    <div className="bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20 font-montserrat">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col gap-12 lg:gap-16">
          {/* Header Section */}
          <div className="flex flex-col gap-3 max-w-4xl">
            <div className="relative">
              <h1 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%]">
                Discover Our Office Locations
              </h1>
            </div>
            <p className="text-slate-600 text-sm md:text-base font-medium leading-[150%]">
              Alkina Realty is here to serve you across multiple locations. Whether
              you're looking to meet our team, discuss real estate
              opportunities, or simply drop by for a chat, we have offices
              conveniently located to serve your needs.
            </p>
          </div>

          {/* Main Content */}
          <div className="flex flex-col gap-8 lg:gap-10">
            {/* Tabs */}
            <div className="flex justify-start">
              <div className="inline-flex p-2 items-start gap-2 bg-gray-100">
                <button
                  onClick={() => setActiveTab("all")}
                  className={`px-4 py-3 text-base font-medium leading-[150%] transition-colors ${
                    activeTab === "all"
                      ? "bg-white border border-gray-200 text-primary shadow-sm"
                      : "border border-transparent text-slate-600 hover:bg-white/50"
                  }`}
                >
                  All
                </button>
                <button
                  onClick={() => setActiveTab("regional")}
                  className={`px-4 py-3 text-base font-medium leading-[150%] transition-colors ${
                    activeTab === "regional"
                      ? "bg-white border border-gray-200 text-primary shadow-sm"
                      : "border border-transparent text-slate-600 hover:bg-white/50"
                  }`}
                >
                  Regional
                </button>
                <button
                  onClick={() => setActiveTab("international")}
                  className={`px-4 py-3 text-base font-medium leading-[150%] transition-colors ${
                    activeTab === "international"
                      ? "bg-white border border-gray-200 text-primary shadow-sm"
                      : "border border-transparent text-slate-600 hover:bg-white/50"
                  }`}
                >
                  International
                </button>
              </div>
            </div>

            {/* Office Cards */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6">
              {activeTab === "all" && (
                <>
                  <OfficeCard {...offices.main} />
                  <OfficeCard {...offices.regional} />
                </>
              )}
              {activeTab === "regional" && (
                <OfficeCard {...offices.regional} />
              )}
              {activeTab === "international" && (
                <div className="col-span-1 lg:col-span-2 p-8 lg:p-12 border border-gray-200 bg-gray-50 flex items-center justify-center">
                  <p className="text-slate-600 text-base md:text-lg text-center">
                    International offices coming soon. Stay tuned for updates!
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

